import { CommonModalActionProps } from "@/components/common/modal/contracts/modal.contracts";
import { Button } from "@/ui/cva/Button";
import { closeModal } from "@/ui/Modal2";
import { useTranslation } from "next-i18next";

export const COMMON_MODAL_ACTION_CANCEL_RESPONSE = undefined;

export const CommonModalActionCancel = ({
  modal,
  color,
  label,
  className,
}: CommonModalActionProps & { label?: string }) => {
  const { t } = useTranslation();

  const handleClick = () => {
    closeModal(modal, COMMON_MODAL_ACTION_CANCEL_RESPONSE);
  };

  return (
    <Button
      color={color ?? "brand"}
      size="large"
      appearance="outlined"
      className={className}
      onClick={handleClick}
    >
      {label ?? t("common:common-cancel")}
    </Button>
  );
};
